// @ts-nocheck
import { useParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Calendar, MessageSquare, NotebookPen } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function OneOnOneDetailPlaceholder() {
  const { id } = useParams<{ id: string }>()

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <header>
          <h1 className="text-3xl font-bold text-foreground mb-2">1-on-1 Session Overview</h1>
          <p className="text-muted-foreground">
            Session ID: <span className="font-mono">{id}</span>
          </p>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <Calendar className="h-5 w-5 text-primary" />
              Agenda & scheduling
            </CardTitle>
            <CardDescription>
              The detailed agenda, notes, and ratings UI from the Next.js implementation needs to be ported to Vite. This
              placeholder keeps the route alive so links do not break during the migration.
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <MessageSquare className="h-5 w-5 text-primary" />
              Conversation history
            </CardTitle>
            <CardDescription>
              Historical notes and shared feedback will surface here once the data hooks are migrated.
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <NotebookPen className="h-5 w-5 text-primary" />
              Action items
            </CardTitle>
            <CardDescription>
              Action tracking is still available in the legacy UI. Port the reusable components when consolidating the frontends.
            </CardDescription>
          </CardHeader>
        </Card>

        <div className="flex flex-wrap gap-3">
          <Button asChild>
            <Link to="/dashboard/one-on-ones">Back to sessions</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to={`/dashboard/one-on-ones/${id}/edit`}>Edit session</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
